import { Price, Stack, Text, UnderlineButton } from "flicket-ui";
import { useContext, useState } from "react";
import { useOrganization } from "~hooks";
import { OrderSummaryContext } from "./OrderSummaryContext";
import Skeleton from "react-loading-skeleton";

export const SinglePageCheckoutServiceFees = () => {
  const { isLoading, totalServiceCost, renderServiceCosts } = useContext(
    OrderSummaryContext
  );
  const [showDetails, setShowDetails] = useState(false);
  const { organization } = useOrganization();

  return (
    <Stack direction={"vertical"}>
      <Stack
        justifyContent={"space-between"}
        flex={1}
        alignItems={"center"}
        // need to set minHeight to avoid collapsing when showDetails is true and no totalFees are shown
        minHeight={"24px"}
      >
        <UnderlineButton
          onClick={() => setShowDetails(!showDetails)}
          color={"N800"}
        >
          Service costs
        </UnderlineButton>
        {!showDetails && (
          <Text variant="regular">
            {isLoading ? (
              <Skeleton width={100} height="10px" />
            ) : (
              <Price
                price={totalServiceCost}
                currency={organization.currency}
              />
            )}
          </Text>
        )}
      </Stack>
      {showDetails && (
        <Stack direction={"vertical"} gap={1} mt={1}>
          {renderServiceCosts()}
        </Stack>
      )}
    </Stack>
  );
};
